module.exports = __webpack_public_path__ + "img/part3-label3.345ef2a0.png";